{
  "INTEGRATION_SETTINGS": {
    "SHOPIFY": {
      "DELETE": {
        "TITLE": "Delete Shopify Integration",
        "MESSAGE": "Are you sure you want to delete the Shopify integration?"
      },
      "STORE_URL": {
        "TITLE": "Connect Shopify Store",
        "LABEL": "Store URL",
        "PLACEHOLDER": "your-store.myshopify.com",
        "HELP": "Enter your Shopify store's myshopify.com URL",
        "CANCEL": "Скасувати",
        "SUBMIT": "Connect Store"
      },
      "ERROR": "There was an error connecting to Shopify. Please try again or contact support if the issue persists."
    },
    "HEADER": "Інтеграції",
    "DESCRIPTION": "Контакт-центр інтегрується з багатьма інструментами та сервісами, щоб підвищити ефективність вашої команди. Перегляньте список нижче, щоб налаштувати ваші улюблені застосунки.",
    "LEARN_MORE": "Learn more about integrations",
    "LOADING": "Fetching integrations",
    "CAPTAIN": {
      "DISABLED": "Captain is not enabled on your account.",
      "CLICK_HERE_TO_CONFIGURE": "Click here to configure",
      "LOADING_CONSOLE": "Loading Captain Console...",
      "FAILED_TO_LOAD_CONSOLE": "Failed to load Captain Console. Please refresh and try again."
    },
    "WEBHOOK": {
      "SUBSCRIBED_EVENTS": "Події з підпискою",
      "LEARN_MORE": "Learn more about webhooks",
      "FORM": {
        "CANCEL": "Скасувати",
        "DESC": "Вебхуки автоматично повідомляють про те, що відбувається у вашому обліковому записі. Будь ласка, введіть дійсний URL для налаштування зворотного виклику.",
        "SUBSCRIPTIONS": {
          "LABEL": "Події",
          "EVENTS": {
            "CONVERSATION_CREATED": "Розмову створено",
            "CONVERSATION_STATUS_CHANGED": "Статус розмови змінено",
            "CONVERSATION_UPDATED": "Розмову оновлено",
            "MESSAGE_CREATED": "Повідомлення створено",
            "MESSAGE_UPDATED": "Повідомлення оновлено",
            "WEBWIDGET_TRIGGERED": "Віджет онлайн чату відкрий користувачем",
            "CONTACT_CREATED": "Контакт створено",
            "CONTACT_UPDATED": "Контакт оновлено",
            "INBOX_CREATED": "Інбокс створено",
            "JARABOT_EVENT": "Внутрішні події"
          }
        },
        "END_POINT": {
          "LABEL": "URL вебхука",
          "PLACEHOLDER": "Example: {webhookExampleURL}",
          "ERROR": "Будь ласка, введіть правильний URL"
        },
        "EDIT_SUBMIT": "Оновити вебхук",
        "ADD_SUBMIT": "Створити вебхук"
      },
      "TITLE": "Веб-хук",
      "CONFIGURE": "Настроїти",
      "HEADER": "Налаштування вебхука",
      "HEADER_BTN_TXT": "Додати новий вебхук",
      "LOADING": "Отримання прикріплених вебхуків",
      "SEARCH_404": "Немає елементів, що відповідають запиту",
      "SIDEBAR_TXT": "<p><b>Вебхуки</b> </p> <p>Вебхуки - це виклики по HTTP, які можна налаштувати для кожного облікового запису. Вебхук виклики будуть відбуватися при подіях, наприклад при нових зверненнях. Ви можете створити один чи кілька вебхуків. <br /><br /> Для створення <b>вебхука</b>, натисніть кнопку <b>Додати новий вебхук</b>. Ви тако можете видаляти вебхуки, натиснувши кнопку Видалити.</p>",
      "LIST": {
        "404": "Немає налаштованих вебхуків для цього облікового запису.",
        "TITLE": "Керування вебхуками",
        "TABLE_HEADER": {
          "WEBHOOK_ENDPOINT": "Кінцева точка вебхука",
          "ACTIONS": "Дії"
        }
      },
      "EDIT": {
        "BUTTON_TEXT": "Редагувати",
        "TITLE": "Редагувати вебхук",
        "API": {
          "SUCCESS_MESSAGE": "Налаштування вебхуків успішно оновлено",
          "ERROR_MESSAGE": "Не вдалося підключитися до Woot Server, спробуйте ще раз пізніше"
        }
      },
      "ADD": {
        "CANCEL": "Скасувати",
        "TITLE": "Додати новий вебхук",
        "API": {
          "SUCCESS_MESSAGE": "Налаштування вебхуків успішно додано",
          "ERROR_MESSAGE": "Не вдалося підключитися до Woot Server, спробуйте ще раз пізніше"
        }
      },
      "DELETE": {
        "BUTTON_TEXT": "Видалити",
        "API": {
          "SUCCESS_MESSAGE": "Вебхук успішно видалено",
          "ERROR_MESSAGE": "Не вдалося підключитися до Woot Server, спробуйте ще раз пізніше"
        },
        "CONFIRM": {
          "TITLE": "Підтвердження видалення",
          "MESSAGE": "Ви впевнені, що хочете видалити webhook? ({webhookURL})",
          "YES": "Так, видалити ",
          "NO": "Ні, залиште"
        }
      },
      "DISABLED_BADGE": "Вимкнено",
      "DISABLED_REASON": "Автоматично вимкнено після {count} послідовних збоїв. Остання помилка: {error}",
      "ENABLE": {
        "BUTTON_TEXT": "Увімкнути",
        "API": {
          "SUCCESS_MESSAGE": "Вебхук успішно увімкнено",
          "ERROR_MESSAGE": "Не вдалося увімкнути вебхук, будь ласка, спробуйте ще раз пізніше"
        }
      }
    },
    "SLACK": {
      "DELETE": "Видалити",
      "DELETE_CONFIRMATION": {
        "TITLE": "Видалити інтеграцію",
        "MESSAGE": "Ви впевнені, що бажаєте видалити інтеграцію? Виконання цього призведе до втрати доступу до розмов на робочому місці Slack."
      },
      "HELP_TEXT": {
        "TITLE": "Використання Slack інтеграцію",
        "BODY": "Завдяки цій інтеграції всі ваші вхідні розмови синхронізуватимуться з каналом ***{selectedChannelName}*** у вашому робочому просторі Slack. Ви можете керувати всіма розмовами з клієнтами прямо в каналі й ніколи не пропустите повідомлення.\n\nОсь основні функції інтеграції:\n\n**Відповідайте на розмови прямо зі Slack:** Щоб відповісти на розмову в каналі Slack ***{selectedChannelName}***, напишіть повідомлення та надішліть його як гілку. Це створить відповідь клієнту через контакт-центр. Ось і все!\n\n **Створюйте приватні нотатки:** Якщо ви хочете створити приватну нотатку замість відповіді, почніть повідомлення з ***`note:`***. Так ваше повідомлення залишиться приватним і клієнт його не побачить.\n\n**Пов'язуйте профіль агента:** Якщо людина, яка відповіла в Slack, має профіль агента в контакт-центрі з тією ж електронною адресою, відповіді автоматично пов'язуються з цим профілем агента. Так ви легко бачите, хто, що і коли сказав. Якщо ж у того, хто відповідає, немає пов'язаного профілю агента, клієнт бачить відповіді від профілю бота.",
        "SELECTED": "вибрано"
      },
      "SELECT_CHANNEL": {
        "OPTION_LABEL": "Обрати канал",
        "UPDATE": "Оновити",
        "BUTTON_TEXT": "Підключити канал",
        "DESCRIPTION": "Ваш робочий простір Slack повністю пов'язаний з контакт-центром. Але інтеграція в даний час неактивна. Щоб активувати інтеграцію та підключити канал, натисніть кнопку нижче.\n\n**Примітка:** Якщо ви намагаєтеся підключити приватний канал, додайте наш додаток до каналу Slack, перш ніж продовжити цей крок.",
        "ATTENTION_REQUIRED": "Потрібно звернути увагу",
        "EXPIRED": "Ваша інтеграція зі Slack закінчилася. Щоб продовжити отримувати повідомлення в Slack, будь ласка, видаліть інтеграцію і знову підключіть робочу область."
      },
      "UPDATE_ERROR": "Помилка при оновленні інтеграції, будь ласка, спробуйте ще раз",
      "UPDATE_SUCCESS": "Канал успішно підключено",
      "FAILED_TO_FETCH_CHANNELS": "Помилка при підключенні каналів з Slack, будь ласка, спробуйте ще раз"
    },
    "OPEN_AI": {
      "AI_ASSIST": "ШІ асистент",
      "WITH_AI": " {option} з ШІ ",
      "OPTIONS": {
        "REPLY_SUGGESTION": "Пропозиція для відповіді",
        "SUMMARIZE": "Підсумувати",
        "REPHRASE": "Покращити написання",
        "FIX_SPELLING_GRAMMAR": "Виправити правопис і граматику",
        "SHORTEN": "Скоротити",
        "EXPAND": "Розширити",
        "MAKE_FRIENDLY": "Змінити сигнал повідомлення на дружній",
        "MAKE_FORMAL": "Використовувати формальний сигнал",
        "SIMPLIFY": "Спростити",
        "TRANSLATE": "Перекласти",
        "TRANSLATE_TO_MAJORITY_LANGUAGE": "Перекласти на основну мову"
      },
      "ASSISTANCE_MODAL": {
        "DRAFT_TITLE": "Вміст чернетки",
        "GENERATED_TITLE": "Згенерований вміст",
        "AI_WRITING": "ШІ пише",
        "BUTTONS": {
          "APPLY": "Використати цю пропозицію",
          "CANCEL": "Скасувати"
        }
      },
      "CTA_MODAL": {
        "TITLE": "Інтегрувати з OpenAI",
        "DESC": "Додайте розширені функції AI в панель керування за допомогою моделей GPT OpenAI. Для початку введіть ключ API з вашого облікового запису OpenAI.",
        "KEY_PLACEHOLDER": "Введіть ваш ключ OpenAI API",
        "BUTTONS": {
          "NEED_HELP": "Потрібна допомога?",
          "DISMISS": "Відхилити",
          "FINISH": "Завершити налаштування"
        },
        "DISMISS_MESSAGE": "Ви можете налаштувати інтеграцію OpenAI пізніше, коли забажаєте.",
        "SUCCESS_MESSAGE": "Інтеграція з OpenAI успішно налаштована"
      },
      "TITLE": "Покращити з ШІ",
      "SUMMARY_TITLE": "Резюме ШІ",
      "REPLY_TITLE": "Пропозиції відповіді від ШІ",
      "SUBTITLE": "Поліпшена відповідь буде згенерована за допомогою AI, основана на вашій чернетці.",
      "TONE": {
        "TITLE": "Тон",
        "OPTIONS": {
          "PROFESSIONAL": "Професійний",
          "FRIENDLY": "Дружній"
        }
      },
      "BUTTONS": {
        "GENERATE": "Згенерувати",
        "GENERATING": "Генерація...",
        "CANCEL": "Скасувати"
      },
      "GENERATE_ERROR": "Сталася помилка при обробці контенту, будь ласка, спробуйте ще раз"
    },
    "DELETE": {
      "BUTTON_TEXT": "Видалити",
      "API": {
        "SUCCESS_MESSAGE": "Інтеграція успішно видалена"
      }
    },
    "CONNECT": {
      "BUTTON_TEXT": "Підключитися"
    },
    "DASHBOARD_APPS": {
      "TITLE": "Додатки для головного екрану",
      "HEADER_BTN_TXT": "Додати нову інформаційну панель",
      "SIDEBAR_TXT": "<p><b>Панель управління</b></p><p>Додатки дозволяють організаціям вставляти в панель керування інформацію, щоб надати контекст агентам підтримки клієнтів. Ця функція дозволяє створювати додаток незалежно і вставляти його в панелі управління відомості про користувача, їхні замовлення або історію попередніх платежів.</p><p>Коли ви вставляєте свій застосунок у панель керування, ваша програма отримає контекст розмови і зв'яжеться як віконна подія. Налаштуйте слухача для заходу повідомлення на вашій сторінці, щоб отримати контекст.</p><p>Щоб додати нову панель керування, натисніть кнопку 'Додати нову програму'.</p>",
      "DESCRIPTION": "Додатки дозволяють організаціям вбудовувати інформаційну панель керування і надавати контекст для агентів підтримки клієнтів. Ця функція дозволяє створювати додаток незалежно і додавати інформацію, що надавали про користувача, його замовлення або історію платежів.",
      "LEARN_MORE": "Learn more about Dashboard Apps",
      "LIST": {
        "404": "Поки що немає налаштованих додатків в цьому акаунті",
        "LOADING": "Отримання додатків панелі керування...",
        "TABLE_HEADER": {
          "NAME": "Ім'я",
          "ENDPOINT": "Endpoint"
        },
        "EDIT_TOOLTIP": "Редагувати додаток",
        "DELETE_TOOLTIP": "Видалити додаток"
      },
      "FORM": {
        "TITLE_LABEL": "Ім'я",
        "TITLE_PLACEHOLDER": "Введіть ім'я для вашої інформаційної панелі",
        "TITLE_ERROR": "Потрібно ім'я для головної панелі",
        "URL_LABEL": "Endpoint",
        "URL_PLACEHOLDER": "Введіть URL кінцевої точки, де розміщено ваш додаток",
        "URL_ERROR": "Потрібно вказати допустиму URL-адресу"
      },
      "CREATE": {
        "HEADER": "Додати нову інформаційну панель",
        "FORM_SUBMIT": "Додати",
        "FORM_CANCEL": "Скасувати",
        "API_SUCCESS": "Панель інструментів успішно налаштовано",
        "API_ERROR": "Не вдалося створити додаток. Будь ласка, спробуйте ще раз пізніше"
      },
      "UPDATE": {
        "HEADER": "Редагувати інформаційну панель",
        "FORM_SUBMIT": "Оновити",
        "FORM_CANCEL": "Скасувати",
        "API_SUCCESS": "Панель інструментів успішно оновлено",
        "API_ERROR": "Не вдалося оновити додаток. Будь ласка, спробуйте ще раз пізніше"
      },
      "DELETE": {
        "CONFIRM_YES": "Так, видалити це",
        "CONFIRM_NO": "Ні, зберегти це",
        "TITLE": "Підтвердіть видалення",
        "MESSAGE": "Ви дійсно бажаєте видалити програму - {appName}?",
        "API_SUCCESS": "Панель інструментів успішно видалено",
        "API_ERROR": "Не вдалося видалити додаток. Будь ласка, спробуйте ще раз пізніше"
      }
    },
    "LINEAR": {
      "ADD_OR_LINK_BUTTON": "Create/Link Linear Issue",
      "LOADING": "Fetching linear issues...",
      "LOADING_ERROR": "There was an error fetching the linear issues, please try again",
      "CREATE": "Створити",
      "LINK": {
        "SEARCH": "Search issues",
        "SELECT": "Select issue",
        "TITLE": "Лінк",
        "EMPTY_LIST": "No linear issues found",
        "LOADING": "Loading",
        "ERROR": "There was an error fetching the linear issues, please try again",
        "LINK_SUCCESS": "Issue linked successfully",
        "LINK_ERROR": "There was an error linking the issue, please try again",
        "LINK_TITLE": "Conversation (#{conversationId}) with {name}"
      },
      "ADD_OR_LINK": {
        "TITLE": "Create/link linear issue",
        "DESCRIPTION": "Create Linear issues from conversations, or link existing ones for seamless tracking.",
        "FORM": {
          "TITLE": {
            "LABEL": "Назва",
            "PLACEHOLDER": "Enter title",
            "REQUIRED_ERROR": "Необхідно вказати назву"
          },
          "DESCRIPTION": {
            "LABEL": "Опис",
            "PLACEHOLDER": "Enter description"
          },
          "TEAM": {
            "LABEL": "Команда",
            "PLACEHOLDER": "Виберіть команду",
            "SEARCH": "Search team",
            "REQUIRED_ERROR": "Team is required"
          },
          "ASSIGNEE": {
            "LABEL": "Assignee",
            "PLACEHOLDER": "Select assignee",
            "SEARCH": "Search assignee"
          },
          "PRIORITY": {
            "LABEL": "Пріоритет",
            "PLACEHOLDER": "Оберіть пріоритет",
            "SEARCH": "Search priority"
          },
          "LABEL": {
            "LABEL": "Мітка",
            "PLACEHOLDER": "Select label",
            "SEARCH": "Search label"
          },
          "STATUS": {
            "LABEL": "Статус",
            "PLACEHOLDER": "Select status",
            "SEARCH": "Search status"
          },
          "PROJECT": {
            "LABEL": "Project",
            "PLACEHOLDER": "Select project",
            "SEARCH": "Search project"
          }
        },
        "CREATE": "Створити",
        "CANCEL": "Скасувати",
        "CREATE_SUCCESS": "Issue created successfully",
        "CREATE_ERROR": "There was an error creating the issue, please try again",
        "LOADING_TEAM_ERROR": "There was an error fetching the teams, please try again",
        "LOADING_TEAM_ENTITIES_ERROR": "There was an error fetching the team entities, please try again"
      },
      "ISSUE": {
        "STATUS": "Статус",
        "PRIORITY": "Пріоритет",
        "ASSIGNEE": "Assignee",
        "LABELS": "Мітки",
        "CREATED_AT": "Created at {createdAt}"
      },
      "UNLINK": {
        "TITLE": "Unlink",
        "SUCCESS": "Issue unlinked successfully",
        "ERROR": "There was an error unlinking the issue, please try again"
      },
      "DELETE": {
        "TITLE": "Are you sure you want to delete the integration?",
        "MESSAGE": "Are you sure you want to delete the integration?",
        "CONFIRM": "Так, видалити",
        "CANCEL": "Скасувати"
      }
    }
  },
  "CAPTAIN": {
    "NAME": "Captain",
    "HEADER_KNOW_MORE": "Know more",
    "COPILOT": {
      "SEND_MESSAGE": "Надіслати...",
      "LOADER": "Captain is thinking",
      "YOU": "Ви",
      "USE": "Use this",
      "RESET": "Reset",
      "SELECT_ASSISTANT": "Select Assistant",
      "EMPTY_MESSAGE": "Виникла помилка під час генерації відповіді. Будь ласка, спробуйте ще раз."
    },
    "PAYWALL": {
      "TITLE": "Upgrade to use Captain AI",
      "AVAILABLE_ON": "Captain is not available on the free plan.",
      "UPGRADE_PROMPT": "Upgrade your plan to get access to our assistants, copilot and more.",
      "UPGRADE_NOW": "Оновити зараз",
      "CANCEL_ANYTIME": "Ви можете змінити або скасувати план у будь-який час"
    },
    "ENTERPRISE_PAYWALL": {
      "AVAILABLE_ON": "Captain AI feature is only available in a paid plan.",
      "UPGRADE_PROMPT": "Upgrade your plan to get access to our assistants, copilot and more.",
      "ASK_ADMIN": "Будь ласка, зверніться до адміністратора для оновлення."
    },
    "BANNER": {
      "RESPONSES": "You've used over 80% of your response limit. To continue using Captain AI, please upgrade.",
      "DOCUMENTS": "Document limit reached. Upgrade to continue using Captain AI."
    },
    "FORM": {
      "CANCEL": "Скасувати",
      "CREATE": "Створити",
      "EDIT": "Оновити"
    },
    "ASSISTANTS": {
      "HEADER": "Assistants",
      "ADD_NEW": "Create a new assistant",
      "DELETE": {
        "TITLE": "Are you sure to delete the assistant?",
        "DESCRIPTION": "This action is permanent. Deleting this assistant will remove it from all connected inboxes and permanently erase all generated knowledge.",
        "CONFIRM": "Так, видалити",
        "SUCCESS_MESSAGE": "The assistant has been successfully deleted",
        "ERROR_MESSAGE": "There was an error deleting the assistant, please try again."
      },
      "FORM_DESCRIPTION": "Fill out the details below to name your assistant, describe its purpose, and specify the product it will support.",
      "CREATE": {
        "TITLE": "Create an assistant",
        "SUCCESS_MESSAGE": "The assistant has been successfully created",
        "ERROR_MESSAGE": "There was an error creating the assistant, please try again."
      },
      "FORM": {
        "NAME": {
          "LABEL": "Assistant Name",
          "PLACEHOLDER": "Enter a name for the assistant",
          "ERROR": "Please provide a name for the assistant"
        },
        "DESCRIPTION": {
          "LABEL": "Assistant Description",
          "PLACEHOLDER": "Describe how and where this assistant will be used",
          "ERROR": "A description is required"
        },
        "PRODUCT_NAME": {
          "LABEL": "Product Name",
          "PLACEHOLDER": "Enter the name of the product this assistant is designed for",
          "ERROR": "The product name is required"
        },
        "FEATURES": {
          "TITLE": "Особливості",
          "ALLOW_CONVERSATION_FAQS": "Generate FAQs from resolved conversations",
          "ALLOW_MEMORIES": "Capture key details as memories from customer interactions."
        }
      },
      "EDIT": {
        "TITLE": "Update the assistant",
        "SUCCESS_MESSAGE": "The assistant has been successfully updated",
        "ERROR_MESSAGE": "There was an error updating the assistant, please try again."
      },
      "OPTIONS": {
        "EDIT_ASSISTANT": "Edit Assistant",
        "DELETE_ASSISTANT": "Delete Assistant",
        "VIEW_CONNECTED_INBOXES": "View connected inboxes"
      },
      "EMPTY_STATE": {
        "TITLE": "No assistants available",
        "SUBTITLE": "Create an assistant to provide quick and accurate responses to your users. It can learn from your help articles and past conversations.",
        "FEATURE_SPOTLIGHT": {
          "TITLE": "Captain Assistant",
          "NOTE": "Captain Assistant engages directly with customers, learns from your help docs and past conversations, and delivers instant, accurate responses. It handles the initial queries, providing quick resolutions before  transferring to an agent when needed."
        }
      }
    },
    "DOCUMENTS": {
      "HEADER": "Documents",
      "ADD_NEW": "Create a new document",
      "RELATED_RESPONSES": {
        "TITLE": "Related FAQs",
        "DESCRIPTION": "These FAQs are generated directly from the document."
      },
      "FORM_DESCRIPTION": "Enter the URL of the document to add it as a knowledge source and choose the assistant to associate it with.",
      "CREATE": {
        "TITLE": "Add a document",
        "SUCCESS_MESSAGE": "The document has been successfully created",
        "ERROR_MESSAGE": "There was an error creating the document, please try again."
      },
      "FORM": {
        "URL": {
          "LABEL": "URL",
          "PLACEHOLDER": "Enter the URL of the document",
          "ERROR": "Please provide a valid URL for the document"
        },
        "ASSISTANT": {
          "LABEL": "Assistant",
          "PLACEHOLDER": "Select the assistant",
          "ERROR": "The assistant field is required"
        }
      },
      "DELETE": {
        "TITLE": "Are you sure to delete the document?",
        "DESCRIPTION": "This action is permanent. Deleting this document will permanently erase all generated knowledge.",
        "CONFIRM": "Так, видалити",
        "SUCCESS_MESSAGE": "The document has been successfully deleted",
        "ERROR_MESSAGE": "There was an error deleting the document, please try again."
      },
      "OPTIONS": {
        "VIEW_RELATED_RESPONSES": "View Related Responses",
        "DELETE_DOCUMENT": "Delete Document"
      },
      "EMPTY_STATE": {
        "TITLE": "No documents available",
        "SUBTITLE": "Documents are used by your assistant to generate FAQs. You can import documents to provide context for your assistant.",
        "FEATURE_SPOTLIGHT": {
          "TITLE": "Captain Document",
          "NOTE": "A document in Captain serves as a knowledge resource for the assistant. By connecting your help center or guides, Captain can analyze the content and provide accurate responses for customer inquiries."
        }
      }
    },
    "RESPONSES": {
      "HEADER": "FAQs",
      "ADD_NEW": "Create new FAQ",
      "DOCUMENTABLE": {
        "CONVERSATION": "Conversation #{id}"
      },
      "SELECTED": "{count} selected",
      "BULK_APPROVE_BUTTON": "Approve",
      "BULK_DELETE_BUTTON": "Видалити",
      "BULK_APPROVE": {
        "SUCCESS_MESSAGE": "FAQs approved successfully",
        "ERROR_MESSAGE": "There was an error approving the FAQs, please try again."
      },
      "BULK_DELETE": {
        "TITLE": "Delete FAQs?",
        "DESCRIPTION": "Are you sure you want to delete the selected FAQs? This action cannot be undone.",
        "CONFIRM": "Yes, delete all",
        "SUCCESS_MESSAGE": "FAQs deleted successfully",
        "ERROR_MESSAGE": "There was an error deleting the FAQs, please try again."
      },
      "DELETE": {
        "TITLE": "Are you sure to delete the FAQ?",
        "DESCRIPTION": "",
        "CONFIRM": "Так, видалити",
        "SUCCESS_MESSAGE": "FAQ deleted successfully",
        "ERROR_MESSAGE": "There was an error deleting the FAQ, please try again."
      },
      "FILTER": {
        "ASSISTANT": "Assistant: {selected}",
        "STATUS": "Status: {selected}",
        "ALL_ASSISTANTS": "Всі"
      },
      "STATUS": {
        "TITLE": "Статус",
        "PENDING": "Очікує",
        "APPROVED": "Approved",
        "ALL": "Всі"
      },
      "FORM_DESCRIPTION": "Add a question and its corresponding answer to the knowledge base and select the assistant it should be associated with.",
      "CREATE": {
        "TITLE": "Add an FAQ",
        "SUCCESS_MESSAGE": "The response has been added successfully.",
        "ERROR_MESSAGE": "An error occurred while adding the response. Please try again."
      },
      "FORM": {
        "QUESTION": {
          "LABEL": "Question",
          "PLACEHOLDER": "Enter the question here",
          "ERROR": "Please provide a valid question."
        },
        "ANSWER": {
          "LABEL": "Answer",
          "PLACEHOLDER": "Enter the answer here",
          "ERROR": "Please provide a valid answer."
        },
        "ASSISTANT": {
          "LABEL": "Assistant",
          "PLACEHOLDER": "Select an assistant",
          "ERROR": "Please select an assistant."
        }
      },
      "EDIT": {
        "TITLE": "Update the FAQ",
        "SUCCESS_MESSAGE": "The FAQ has been successfully updated",
        "ERROR_MESSAGE": "There was an error updating the FAQ, please try again",
        "APPROVE_SUCCESS_MESSAGE": "The FAQ was marked as approved"
      },
      "OPTIONS": {
        "APPROVE": "Mark as approved",
        "EDIT_RESPONSE": "Edit FAQ",
        "DELETE_RESPONSE": "Delete FAQ"
      },
      "EMPTY_STATE": {
        "TITLE": "No FAQs Found",
        "SUBTITLE": "FAQs help your assistant provide quick and accurate answers to questions from your customers. They can be generated automatically from your content or can be added manually.",
        "FEATURE_SPOTLIGHT": {
          "TITLE": "Captain FAQ",
          "NOTE": "Captain FAQs detects common customer questions—whether missing from your knowledge base or frequently asked—and generates relevant FAQs to improve support. You can review each suggestion and decide whether to approve or reject it."
        }
      }
    },
    "INBOXES": {
      "HEADER": "Connected Inboxes",
      "ADD_NEW": "Connect a new inbox",
      "OPTIONS": {
        "DISCONNECT": "Від'єднатись"
      },
      "DELETE": {
        "TITLE": "Are you sure to disconnect the inbox?",
        "DESCRIPTION": "",
        "CONFIRM": "Так, видалити",
        "SUCCESS_MESSAGE": "The inbox was successfully disconnected.",
        "ERROR_MESSAGE": "There was an error disconnecting the inbox, please try again."
      },
      "FORM_DESCRIPTION": "Choose an inbox to connect with the assistant.",
      "CREATE": {
        "TITLE": "Connect an Inbox",
        "SUCCESS_MESSAGE": "The inbox was successfully connected.",
        "ERROR_MESSAGE": "An error occurred while connecting the inbox. Please try again."
      },
      "FORM": {
        "INBOX": {
          "LABEL": "Вхідні",
          "PLACEHOLDER": "Choose the inbox to deploy the assistant.",
          "ERROR": "An inbox selection is required."
        }
      },
      "EMPTY_STATE": {
        "TITLE": "No Connected Inboxes",
        "SUBTITLE": "Connecting an inbox allows the assistant to handle initial questions from your customers before transferring them to you."
      }
    }
  }
}
